module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Bold.e38d0f68.woff2";